import { render, staticRenderFns } from "./MdTms.vue?vue&type=template&id=4d631c4e&scoped=true&"
import script from "./MdTms.vue?vue&type=script&lang=js&"
export * from "./MdTms.vue?vue&type=script&lang=js&"
import style0 from "./MdTms.vue?vue&type=style&index=0&id=4d631c4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d631c4e",
  null
  
)

export default component.exports